import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CardModule } from 'primeng/card';
import { PermissionsService } from './services/permissions.service';

@Component({
  selector: 'app-permissions',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './permissions.component.html',
  styleUrl: './permissions.component.css'
})
export class PermissionsComponent {
  service = inject(PermissionsService)

  ngOnInit(): void {
    this.service.title.update((value) => 'Permisos')
  }
}
